import store from '@/store';
import { DirectiveOptions } from 'vue';
import { notLowerVersion, preventClick } from '@/utils';
import { isNullish } from '@tencent/v-common-utils';

/**
 * 用于对点击区域进行客户端版本限制
 *
 * @param {*} { ios = '1.6.30' android = '1.6.30' } 限制的版本号，不传入对应系统则对应端不限制
 * @param {*} { preNeedCheck = true } 在进行版本校验前先判断是否需要进行校验，如朋友圈上传截图功能中，非朋友圈的活动前置校验为false，不需要进行版本校验
 * @param {*} { text } 版本校验不通过之后，弹窗的提示信息
 * @return {*}  {DirectiveOptions}
 */
const directiveOption: DirectiveOptions = {
  inserted(el: HTMLElement, binding) {
    const value = binding.value as {
      [key: string]: string | boolean;
    };
    const preNeedCheck = value?.preNeedCheck;
    if (!value) {
      return;
    }
    const {
      device: {
        system,
      } = {},
      nativeVersion,
    } = store.state?.initialGlobalData;
    let elementValid = true;
    if (system && typeof system === 'string') {
      const targetVersion = value[system.toLowerCase()];
      if (targetVersion && typeof targetVersion === 'string') {
        elementValid = notLowerVersion(nativeVersion, targetVersion);
      }
    }
    if (!elementValid && (!isNullish(preNeedCheck) ? preNeedCheck : true)) {
      preventClick(el, (value.text as string) || '当前秒剪版本较低，参与最新活动及体验新功能，请前往应用商店，将秒剪 App 更新至最新版');
    }
  },
};

export default directiveOption;
